var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "17", height: "17", viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.7 4.2L5.5 8l-4.3 4.3a1 1 0 0 0 0 1.4l2.1 2.1a1 1 0 0 0 1.4 0L9 11.5l4.24 4.24a1 1 0 0 0 1.46-.06l1.7-1.98a1 1 0 0 0-.05-1.35L12.5 8.5l3.8-3.8a1 1 0 0 0 0-1.4l-2.13-2.13a1 1 0 0 0-1.38-.04L8.5 5 4.7 1.2a1 1 0 0 0-1.4 0L1.7 2.8a1 1 0 0 0 0 1.4z", fill: "#DBD9D3" })
  );
});